<div class="workflow-config-container">
    <form [formGroup]="workflowForm">
        <mat-card>
            <div *ngIf="!isEditable" class="config-edit-options" fxLayoutAlign="space-between">
                <div class="edit-option table-form-field">
                    <mat-form-field id="config-addConfigName">
                        <mat-label>Configuration Name</mat-label>
                        <input matInput placeholder="" formControlName="cngName">
                        <mat-error
                            *ngIf="workflowForm.controls['cngName'].errors?.['required'] || workflowForm.controls['cngName'].errors?.['maxlength']">{{getConfigurationName()}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="edit-option table-form-field"
                    [id]="(tourGuideService.isStartTour ? tourGuideIds.configBuilder.workflow.selectConfig.id :'')">
                    <!-- dynamic dropdown component -->
                    <app-dynamic-dropdown [data]="workflowData" [isRootNode]="true" [isWorkflowConfig]="true"
                        [isSelect]="true" [childFormControl]="convertToFormControl(workflowForm.get('wfhId'))"
                        class="wd-85" [title]="'Choose Workflow'" [placeholder]="'Select any workflow'"
                        (itemSelected)="onDynamicDropdownChange($event)">
                    </app-dynamic-dropdown>
                </div>

                <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" class="mb">
                    <div>Status</div>
                    <button mat-raised-button color="primary" class="status-button background-clr">Active</button>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center" class="pad-1rem">
                <!-- Single Prerequisite button with conditions -->
                <button *ngIf="(manualWf?.isManualWfTrigger) || (!manualWf?.isManualWfTrigger && configHide)" 
                        mat-raised-button color="primary" 
                        type="button"
                        class="prerequisite-btn"
                        [ngClass]="{
                            'config-builder': !manualWf?.isManualWfTrigger && configHide,
                            'github-actions': manualWf?.isManualWfTrigger
                        }"
                        (click)="openPrerequisite()">Prerequisite</button>
                
                <ng-container *ngIf="configHide && isAddConfig">
                    <button mat-raised-button color="red" (click)="isAddConfigEvent.emit(!isAddConfig)"
                    id="cnfg-cancel">Cancel</button>
                </ng-container>
            </div>

            <div *ngIf="!configHide" [ngClass]="{'expandend-card': !configHide}">
                <div [id]="tourGuideIds.configBuilder.workflow.wfDetailsTab.id">
                    <div *ngIf="!manualWf?.isManualWfTrigger" class="toggle-group">
                        <mat-slide-toggle class="update-qg-check-toggle"
                            [checked]="isSoleFlag" (change)="isSoleFlag = $event.checked" [disabled]="mode=='read'">
                            Sole Trigger
                        </mat-slide-toggle>

                        <mat-slide-toggle class="update-qg-check-toggle"
                            [checked]="updQgCheckFlag" (change)="updQgCheckFlag = $event.checked" [disabled]="mode=='read'">
                            Update Quality Gate Check
                        </mat-slide-toggle>
                    </div>

                    <mat-tab-group [(selectedIndex)]="tourGuideService.dashboardIndex"
                        [id]="tourGuideIds.configBuilder.workflow.toolsThreshHoldTab.table.id" [selectedIndex]="0">
                        <mat-tab *ngIf="mode?.length > 0 && !manualWf?.isManualWfTrigger" label="Workflow details">
                            <app-workflow-details [data]="workflowConfigObj"></app-workflow-details>
                        </mat-tab>

                        <mat-tab
                            [label]="!manualWf?.isManualWfTrigger ? 'Configuration and arguments' : 'Input and arguments'">
                            <div class="config-args-box" *ngIf="workflowConfigObj">
                                <div class="trigger-artifact-container" *ngIf="!manualWf?.isManualWfTrigger">
                                    <app-trigger-and-artifact [mode]="mode" [artifactData]="workflowConfigObj"
                                        [isEditable]="isEditable" (statusChange)="isTriggerFormValid = $event"
                                        (isChangeEvent)="eventChange($event)"
                                        (changeEventValue)="changeEventValue($event)"
                                        [wfSelected]="wfData"></app-trigger-and-artifact>
                                </div>
                                <div [ngStyle]="{'width': !manualWf?.isManualWfTrigger ? '50%' : '100%',
                                                'margin-top': manualWf?.isManualWfTrigger ? '0%' : '2.5%'}">

                                    <div fxLayout="row" fxLayoutAlign=" center" *ngIf="!manualWf?.isManualWfTrigger">
                                        <div class="inputargumentspace" fxFlex="90%">
                                            <mat-card-title>Input and arguments</mat-card-title>
                                        </div>
                                        <mat-icon class="info-icon" fxLayout="row" fxLayoutAlign="end none" fxFlex="10%"
                                            aria-hidden="false"
                                            [matTooltip]="'GitHub issue template list. On selection of any value input arguments are updated.'">info</mat-icon>
                                    </div>
                                    
                                    <app-input-args-parent [mode]="mode" [workflowDtls]="workflowDtls"
                                        [onExpand]="workflowConfigObj" (issueTmpInputs)="issueTmplTable($event)"
                                        (isIssueTmplChecked)="isIssueTmpl($event)"></app-input-args-parent>
                                    <!-- input arguments component -->
                                    <app-input-and-arguments *ngIf="!isIssueTmplChecked" [mode]="mode"
                                        [getData]="inputArgumentList" [isEditable]="isEditable"
                                        [list]="inputArgumentList" [manualTrigger]="manualWf?.isManualWfTrigger"
                                        (inputArgOutput)="addInputArgs($event)" [changeEventStatus]="changeEventStatus"
                                        [changedEventValue]="changedEventValue"></app-input-and-arguments>
                                    <!-- issue template table component -->
                                    <app-issue-tmpl-table *ngIf="isIssueTmplChecked && issueTmplInputs.length > 0"
                                        [input]="issueTmplInputs" [mode]="mode" [manualTrigger]="manualWf?.isManualWfTrigger"
                                        (issueTmplOutput)="addInputArgs($event)"></app-issue-tmpl-table>
                                    <!-- message when no issue template inputs are available/selected -->
                                    <div *ngIf="isIssueTmplChecked && issueTmplInputs.length === 0">
                                        <p class="text">No issue template inputs available. Please add inputs before
                                            saving or updating.</p>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab label="Tools and thresholds">
                            <app-common-table-with-edit [mode]="mode" [isEditable]="isEditable"
                                [(updQgCheckFlag)]="updQgCheckFlag" (addThreshHoldOutput)="addThreshHold($event)"
                                [toolThresholdList]="thresholdList"></app-common-table-with-edit>
                        </mat-tab>

                        <mat-tab label="Labeled Checks" *ngIf="!manualWf?.isManualWfTrigger">
                            <mat-card class="labeled-checks-card">
                                <div class="labeled-checks-container">
                                    <span class="labeled-check-label">Labeled Check:</span>
                                    <mat-form-field appearance="outline" class="labeled-check-field"
                                        [class.disabled-cursor]="mode === 'read'">
                                        <mat-label>Select Labeled Check</mat-label>
                                        <input matInput [formControl]="labelSearchCtrl" [matAutocomplete]="labelAuto"
                                            #labelTrigger="matAutocompleteTrigger">
                                        <mat-icon matSuffix class="dropdown-arrow"
                                            [class.disabled-cursor]="mode === 'read'"
                                            (click)="mode !== 'read' && labelTrigger.openPanel()">arrow_drop_down</mat-icon>
                                        <mat-autocomplete #labelAuto="matAutocomplete" [displayWith]="displayLabelName"
                                            (optionSelected)="onLabelSelected($event)">
                                            <mat-option *ngFor="let label of filteredLabelList" [value]="label">
                                                {{ label.name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-hint *ngIf="labelList?.length === 0">No labeled checks available.</mat-hint>
                                    </mat-form-field>
                                    <button mat-icon-button color="primary" type="button" class="add-label-btn"
                                        [class.disabled-cursor]="mode === 'read'"
                                        [disabled]="mode === 'read'"
                                        aria-label="Add Label" matTooltip="Create/Update a label" (click)="goToLabelsPage()">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </div>
                            </mat-card>
                        </mat-tab>

                    </mat-tab-group>
                </div>

                <div class="save-cancel-container" fxLayout="row">
                    <button mat-raised-button
                        [disabled]="!isValid || (isIssueTmplChecked && issueTmplInputs.length === 0) || isLabeledCheckMissing"
                        [id]="tourGuideIds.configBuilder.workflow.saveBtn.id" *ngIf="!isEditable" color="primary"
                        class="mr-16" type="submit" (click)="addConfig()">Save</button>
                    <div matTooltip="{{(configBuilderService.targetExec && isValid) ? '' : (manualWf?.isManualWfTrigger ? !authService.permissions['run-github-action'] ? commonService.messages.permissionMsg : '':'')}}"
                        [ngClass]="{'disabled-cursor': isLabeledCheckMissing || ((configBuilderService.targetExec && isValid) ? 'false' : (!tourGuideService.isStartTour && manualWf?.isManualWfTrigger ? authService.permissions['run-github-action'] ? (!isValid || mode==='read') : true : (!isValid || mode==='read')))}">
                        <button mat-raised-button
                            [disabled]="isLabeledCheckMissing || ((configBuilderService.targetExec && isValid) ? 'false' : (!tourGuideService.isStartTour && manualWf?.isManualWfTrigger ? authService.permissions['run-github-action'] ? (!isValid || mode==='read') : true : (!isValid || mode==='read')))"
                            *ngIf="isEditable" color="primary" class="mr-16" type="submit" (click)="updateTrigger()"
                            [id]="tourGuideIds.githubAction.expand.run.id">
                            {{ manualWf?.isManualWfTrigger ? 'Run' : 'Update' }}</button>
                    </div>
                    <button mat-raised-button color="red" (click)="updateAddMode()" id="wf-cancel-btn">Cancel</button>
                </div>
            </div>
        </mat-card>
    </form>
</div>